window.onload = function() {
    const slideInItemsRight = document.querySelectorAll(".c_top-fv__slide-animation");
    slideInItemsRight.forEach(item => {
        ScrollTrigger.create({
            trigger: item,
            start: "top 80%",
            onLeaveBack: function() {
                item.classList.remove("js-active");
            },
            onEnter: function() {
                item.classList.add("js-active");
            },
        });
    });
}